import React from 'react';
import './overlay-play.scss';
import PlayIcon from '../../../images/play-button-icon.svg';

const OverlayPlay = ({
    onClick,
    metaData,
    classes,
    buttonClasses,
}) => {

    return (
        <div className={`overlay-play ${classes}`} onClick={onClick}>
            <div className={`play-button ${buttonClasses}`}>
                <PlayIcon />
            </div>
        </div>
    );

};

export default OverlayPlay;
